/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventAttendeePreviewDto } from './eventAttendeePreviewDto';
import { GeoLocationEntity } from './geoLocationEntity';
import { SessionKindDto } from './sessionKindDto';
import { ActivityGroupLogoDto } from './activityGroupLogoDto';


export interface ActiveEventDetailOutputDto { 
    /**
     * Geographic distance from reference point in km
     */
    distanceFromReferenceKm?: number;
    attendeePreview?: Array<EventAttendeePreviewDto>;
    id: string;
    title: string;
    description: string;
    location?: GeoLocationEntity;
    locationAddress: string;
    endLocation?: GeoLocationEntity;
    endLocationAddress?: string;
    maxNbAttendees: number;
    attendeesMode: ActiveEventDetailOutputDto.AttendeesModeEnum;
    startDate: string;
    endDate?: string;
    duration: number;
    level: number;
    group?: ActivityGroupLogoDto;
    background?: string;
    joined: boolean;
    full: boolean;
    sportKeyId: string;
    sportKeyIcon: string;
    /**
     * Internationalized text that resolves to a string
     */
    sportTitle: string;
    sessionKind?: SessionKindDto;
    acceptAnyLvl: boolean;
    levelMatch?: ActiveEventDetailOutputDto.LevelMatchEnum;
    handiFriendly?: boolean;
    isAdmin: boolean;
    isOver: boolean;
    distance: number;
    nbAttendees: number;
    canJoinConversation: boolean;
    privacy?: ActiveEventDetailOutputDto.PrivacyEnum;
    type?: string;
    costPerParticipant?: number;
    isPaidOut?: boolean;
    commissionPercent?: number;
}
export namespace ActiveEventDetailOutputDto {
    export type LevelMatchEnum = 'exact' | 'near' | 'any' | 'far';
    export const LevelMatchEnum = {
        Exact: 'exact' as LevelMatchEnum,
        Near: 'near' as LevelMatchEnum,
        Any: 'any' as LevelMatchEnum,
        Far: 'far' as LevelMatchEnum
    };
    export type AttendeesModeEnum = 'preset' | 'manual';
    export const AttendeesModeEnum = {
        Preset: 'preset' as AttendeesModeEnum,
        Manual: 'manual' as AttendeesModeEnum
    };
    export type PrivacyEnum = 'public' | 'private' | 'members_only';
    export const PrivacyEnum = {
        Public: 'public' as PrivacyEnum,
        Private: 'private' as PrivacyEnum,
        MembersOnly: 'members_only' as PrivacyEnum
    };
}


